import { Flex, Text } from '@chakra-ui/react';
import React from 'react';
import { ApiModelVersionDataPoint } from '../../../api/queries';
import { stripFullModelSuffix } from 'src/utils/model';
import { getModelDateString } from './getModelDateString';

type SelectedModelProps = {
  model: ApiModelVersionDataPoint;
};

export const SelectedModel: React.FC<SelectedModelProps> = ({ model }) => {
  return (
    <Flex alignItems={'flex-start'} flexDir={'column'} maxW="100%">
      <Text
        fontSize="sm"
        whiteSpace={'nowrap'}
        color="sidebar.text"
        maxW="100%"
        textOverflow="ellipsis"
        overflow="hidden">
        {model.alias ? stripFullModelSuffix(model.alias) : model.modelID}
      </Text>
      <Text
        mt={'4px'}
        fontSize="xs"
        whiteSpace="nowrap"
        maxW="100%"
        textOverflow="ellipsis"
        overflow="hidden">
        {getModelDateString(model)}
      </Text>
    </Flex>
  );
};
